import React from "react";

const Services = () => (
  <section>
    <span id="services" className="section-link" />
    <h2>Services</h2>
    <h3>Our expertise includes:</h3>

    <ul className="feature-list">
      <li>Developing robust large-scale UI applications</li>
      <li>Rapid prototyping and iteration</li>
      <li>Implementing pixel-perfect responsive front-ends from Sketch, Photoshop, and Figma</li>
      <li>eCommerce applications</li>
      <li>Web3 and blockchain development</li>
      <li>Architecture and initial technology decisions for greenfield applications</li>
      <li>Migrating legacy applications to newer technologies and architectures</li>
      <li>REST and GraphQL endpoint development and integration</li>
      <li>Engaging marketing and design teams to translate campaigns into digital forms</li>
      <li>Developing and implementing Design Systems</li>
      <li>Accessibility evaluation and implementation</li>
      <li>Troubleshooting difficult challenges</li>
    </ul>
    
  </section>
);

export default Services;
